"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyFormat = void 0;
class CurrencyFormat {
    constructor(locale, options) {
        this._locale = locale;
        this.options = options;
        if (options.isCrypto === false) {
            // We know it's fiat, if not, throw exception
            this.buildFiatFormatter(locale, options);
        }
        else if (options.isCrypto === true) {
            // We know it's crypto
            this.buildCryptoFormatter(locale, options);
        }
        else {
            // If it's undefined or null, we need to decide
            this.buildUnknownFormatter(locale, options);
        }
    }
    buildFiatFormatter(locale, options) {
        const { currency, minimumFractionDigits, maximumFractionDigits } = options;
        this.formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits,
            maximumFractionDigits,
        });
    }
    buildCryptoFormatter(locale, options) {
        const { minimumFractionDigits, maximumFractionDigits } = options;
        const defaultMinFractionDigits = 0;
        const defaultMaxFractionDigits = 20;
        this.formatter = new Intl.NumberFormat(locale, {
            minimumFractionDigits: minimumFractionDigits || defaultMinFractionDigits,
            maximumFractionDigits: maximumFractionDigits || defaultMaxFractionDigits,
        });
    }
    buildUnknownFormatter(locale, options) {
        try {
            // We are going to assume it's a fiat formatter
            this.buildFiatFormatter(locale, options);
        }
        catch (error) {
            // If error is invalid currency code, we try to build a crypto formatter
            const invalidCurrencyCode = error === null || error === void 0 ? void 0 : error.message.includes('Invalid currency code');
            if (invalidCurrencyCode) {
                options.isCrypto = true;
                this.buildCryptoFormatter(locale, options);
            }
            else {
                throw error;
            }
        }
    }
    stripDecimalsIfInteger(parts) {
        const fractionPart = parts.find(x => x.type === 'fraction');
        if (fractionPart && Number(fractionPart.value) === 0) {
            return parts.filter(x => x.type !== 'fraction' && x.type !== 'decimal');
        }
        return parts;
    }
    get locale() {
        return this._locale;
    }
    get isCrypto() {
        return this.options.isCrypto || false;
    }
    format(value) {
        if (!this.options.isCrypto && !this.options.stripDecimalsIfInteger) {
            return this.formatter.format(value);
        }
        return this.formatToParts(value).reduce((pv, cv) => pv + cv.value, '');
    }
    formatToParts(value) {
        let parts = this.formatter.formatToParts(value);
        parts = this.options.stripDecimalsIfInteger
            ? this.stripDecimalsIfInteger(parts)
            : parts;
        if (this.options.isCrypto) {
            parts = [
                ...parts,
                { type: 'literal', value: ' ' },
                { type: 'currency', value: this.options.currency },
            ];
        }
        return parts;
    }
    formatCurrency() {
        return this.formatToParts(undefined).find(x => x.type === 'currency').value;
    }
    formatNumber(value) {
        return this.formatToParts(value)
            .filter(x => !['literal', 'currency'].includes(x.type))
            .reduce((pv, cv) => pv + cv.value, '');
    }
    getSeparators() {
        const numberWithGroupAndDecimalSeparator = 10000.1;
        const separators = this.formatToParts(numberWithGroupAndDecimalSeparator)
            .filter(part => ['group', 'decimal'].includes(part.type))
            .reduce((acc, part) => acc.set(part.type, part.value), new Map());
        return separators;
    }
}
exports.CurrencyFormat = CurrencyFormat;
//# sourceMappingURL=currency-format.js.map